import React from "react"
import Relay from "react-relay"
import { Link } from "react-router"
import "pdfjs-dist/build/pdf.combined"
import PDF from "react-pdf"
import AddFavourite from "../elements/AddFavourite"
import Icon from "../elements/Icon"
import {
  getPDFSrcFromFile,
  getPDFSrcFromResource
} from "../../scripts/resource"
import ImageView from "./ImageView"
import { injectIntl } from "react-intl"
import { default as mediaMessages } from "../../messages/media"
import { getStyleTag, getStyles } from "../../styles/dynamicStyles"

class PDFView extends React.Component {
  state = {
    currentPage: 1,
    scale: 1.0,
    pages: 0
  }

  prevPage = e => {
    e.preventDefault()
    this.setState({
      currentPage: this.state.currentPage > 1 ? this.state.currentPage - 1 : 1
    })
  }

  nextPage = e => {
    e.preventDefault()
    this.setState({
      currentPage:
        this.state.currentPage < this.state.pages
          ? this.state.currentPage + 1
          : this.state.pages
    })
  }

  zoomIn = e => {
    e.preventDefault()
    this.setState({
      scale: this.state.scale + 0.25
    })
  }

  zoomOut = e => {
    e.preventDefault()
    if (this.state.scale > 0.25) {
      this.setState({
        scale: this.state.scale - 0.25
      })
    }
  }

  render() {
    const { resource, viewer, intl } = this.props

    const files = resource && resource.files
    const file =
      this.props.file && files && files.find(f => f.id === this.props.file)
    const pdfSource = file
      ? getPDFSrcFromFile(file)
      : getPDFSrcFromResource(resource)
    const showPdf = !!pdfSource

    return showPdf ? (
      <div>
        {getStyleTag(["c-mviewer__tools"])}
        <ImageView
          file={file}
          resource={resource}
          withDeepZoom={false}
          imgClassName="state-canvas-contain"
          ifNoImage={
            <div className="c-mviewer__overflow">
              <div className="c-mviewer__object c-mviewer__object--pdf">
                <span className="hide for-schema-markup-only" itemProp="url">
                  {pdfSource}
                </span>
                <PDF
                  page={this.state.currentPage}
                  file={pdfSource}
                  scale={this.state.scale}
                  onDocumentComplete={this._onDocumentComplete}
                  onClick={this.nextPage}
                />
              </div>
            </div>
          }
        />

        <Link
          className="overbutton"
          to={`/item/${resource.id}/pdf${file ? `?file=${file.id}` : ""}`}
          title={intl.formatMessage(mediaMessages.viewFullPDF)}
        >
          <span className="overbutton__icon">
            <Icon icon="expand" />
          </span>
          <br />
          <span className="overbutton__text">View PDF</span>
        </Link>
        {!file ? (
          <div
            className="c-mviewer__tools"
            style={getStyles("c-mviewer__tools")}
          >
            <AddFavourite
              resource={resource}
              viewer={viewer}
              className="button"
            />
            <Link
              className="button"
              to={`/item/${resource.id}/pdf`}
              title="View full PDF"
            >
              <Icon icon="expand" />
            </Link>
          </div>
        ) : null}
      </div>
    ) : null
  }

  _onDocumentComplete = pages => {
    this.setState({ pages: pages })
  }
}

export default Relay.createContainer(injectIntl(PDFView), {
  fragments: {
    resource: () => Relay.QL`
    fragment on Resource {
        id
        title
        type
        files {
          id
          type
          documents {
              pdf { url }
          }
        }
        ${ImageView.getFragment("resource")}
        ${AddFavourite.getFragment("resource")}
    }
    `,
    viewer: () => Relay.QL`
      fragment on Viewer {
        ${AddFavourite.getFragment("viewer")}
      }
    `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/modules/PDFView.js